<template>
    <VModal
        transition="slide"
        :name="name"
        height="auto"
        width="100%"
        :scrollable="true"
        :click-to-close="false"
        @before-open="onOpen"
    >
        <div
            class="relative w-full min-h-screen sm:min-h-full sm:max-w-md sm:mt-10 sm:mb-24 sm:shadow-2xl sm:rounded sm:border-yellow-500 sm:border-b-8 xl:mt-20"
            :class="variant || 'bg-white'"
        >
            <div class="p-8 pt-16 sm:p-12">
                <!-- <div
                    v-if="closable"
                    class="absolute top-0 right-0 w-6 h-6 mt-8 mr-8 cursor-pointer"
                > -->
                <!-- prettier-ignore -->
                <!-- <svg
                        :class="closeIconVariant || 'text-grey-200'"
                        role="img" focusable="false" aria-label="Close icon"
                        height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"
                        @click="close">
                        <path fill="currentColor" d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z" />
                    </svg>
                </div> -->
                <slot :on-accept-and-close="onAcceptAndClose" />
            </div>
            <component
                :is="footerBarLink ? 'a' : 'div'"
                v-if="footerBarText"
                target="_blank"
                :href="footerBarLink"
                class="block px-12 pt-5 pb-4 leading-snug text-blue-500 bg-yellow-500"
            >
                <span class="">{{ footerBarText }}</span>
                <!-- prettier-ignore -->
                <svg v-if="footerBarLink" class="inline ml-3" width="7" role="img" focusable="false" aria-label="" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.64223 5.1325L0.774161 9.22378L1.79123 10.2397L6.75 5.15666L1.81654 0L0.75 1.06654L4.64223 5.1325Z" fill="#004876"/>
                </svg>
            </component>
            <p
                v-if="closeText && closable"
                class="bottom-0 left-0 w-full text-center cursor-pointer sm:absolute text-grey-500 sm:text-white sm:-mb-14"
                @click="close"
            >
                {{ closeText }}
            </p>
        </div>
    </VModal>
</template>

<script>
import 'vue-js-modal/dist/styles.css';

export default {
    props: {
        name: {
            type: String,
            required: true
        },
        closable: {
            type: Boolean,
            default: true
        },
        closeText: {
            type: String,
            default: null
        },
        footerBarText: {
            type: String,
            default: null
        },
        footerBarLink: {
            type: String,
            default: null
        },
        variant: {
            type: [String, Boolean],
            default: false
        },
        closeIconVariant: {
            type: [String, Boolean],
            default: false
        }
    },

    data: () => ({
        onAcceptAndClose: () => {}
    }),

    methods: {
        close() {
            this.$modal.hide(this.name);
            this.$emit('close');
        },

        onOpen(options) {
            if (options.params && options.params.onAcceptAndClose) {
                this.onAcceptAndClose = options.params.onAcceptAndClose;
            }
        }
    }
};
</script>

<style scoped>
/* purgecss start ignore */
::v-deep .v--modal {
    @apply flex items-center justify-center bg-transparent;
}

::v-deep .v--modal-box {
    @apply top-0 shadow-none !important;
}

.v--modal-overlay {
    @apply z-40;
    background-color: rgba(0, 0, 0, 0.5);
}
/* purgecss end ignore */
</style>
